import { ColorConf } from "@/config/color";
import { Permission_Notification } from "@/utils/enum";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";

interface EnableNotificationGuideProps {
  permission: NotificationPermission;
}

const EnableNotificationGuide: React.FC<EnableNotificationGuideProps> = ({
  permission
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (permission === Permission_Notification.Denied) {
      setOpen(true);
    }
  }, [permission]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  if (permission !== Permission_Notification.Denied) {
    return null;
  }

  const Icon = isMobile ? SmartphoneIcon : SettingsIcon;

  const description = isMobile
    ? "通知を受け取るには、デバイスの設定で通知を有効にしてください。" /* To receive notifications, please enable them in your device settings. */
    : "通知を受け取るには、ブラウザの設定で通知を有効にしてください。"; /* To receive notifications, please enable them in your browser settings. */

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "8px"
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px 8px"
        }}
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          通知を有効にする {/* Enable Notifications */}
        </Typography>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "16px 24px 24px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Icon sx={{ fontSize: 48, color: ColorConf.PrimaryForWomen }} />
          </Box>

          <Typography variant="body1" sx={{ mb: 2 }}>
            {description}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EnableNotificationGuide;
